import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Dumbbell, ArrowLeft } from "lucide-react";
import { api } from "../api/client";

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Hasło musi mieć minimum 6 znaków");
      return;
    }
    if (password !== confirm) {
      toast.error("Hasła nie są identyczne");
      return;
    }
    setLoading(true);
    try {
      await api("post", "/auth/reset-password", { token, new_password: password });
      toast.success("Hasło zmienione");
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Nie udało się zresetować hasła");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <Card className="auth-card">
            <CardContent className="auth-content" style={{ textAlign: "center", padding: "32px" }}>
              <p>Brak tokenu resetowania. Użyj linku z emaila.</p>
              <Button variant="outline" onClick={() => navigate("/")} style={{ marginTop: 16 }}>
                <ArrowLeft size={16} /> Powrót do logowania
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-brand">
            <div className="brand-icon"><Dumbbell size={28} strokeWidth={1.5} /></div>
            <h1>DuoFit</h1>
          </div>
          <Card className="auth-card">
            <CardContent className="auth-content" style={{ textAlign: "center", padding: "32px" }}>
              <h2 style={{ marginBottom: 8 }}>Hasło zmienione</h2>
              <p style={{ color: "var(--text-secondary)", marginBottom: 16 }}>Możesz się teraz zalogować nowym hasłem.</p>
              <Button onClick={() => navigate("/")}>Zaloguj się</Button>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-brand">
          <div className="brand-icon"><Dumbbell size={28} strokeWidth={1.5} /></div>
          <h1>DuoFit</h1>
        </div>
        <Card className="auth-card">
          <CardContent className="auth-content">
            <h2 style={{ marginBottom: 16 }}>Nowe hasło</h2>
            <form onSubmit={handleSubmit}>
              <div className="field">
                <Label>Nowe hasło</Label>
                <Input type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={6} />
              </div>
              <div className="field">
                <Label>Powtórz hasło</Label>
                <Input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={6} />
              </div>
              <Button type="submit" className="submit-btn" disabled={loading}>
                {loading ? "Zmieniam..." : "Zmień hasło"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
